var transparent = "transparent";
var current = "currentColor";
var brand = "#1B6EBB";
var black = "#000000";
var white = "#FFFFFF";
var success = "#1A875B";
var warning = "#F0A92C";
var error = "#C74E4E";
var disabled = "#C5C5C5";
var annotation = "#FF0099";
var deprecated = {
	transparent: transparent,
	current: current,
	brand: brand,
	"brand-dark": "#0D2D49",
	"brand-light": "#3997EF",
	"brand-medium": "#124C81",
	black: black,
	white: white,
	"brand-ultralight": "#7AB9F4",
	"dark-text": "#2B303C",
	"light-text": "#5A697B",
	"gray-203": "#7296B8",
	"gray-204": "#C8DAEB",
	"gray-205": "#EDEEEF",
	"gray-206": "#F1F4F9",
	"gray-207": "#F7F8FA",
	"gray-208": "#FDFDFF",
	"blue-301": "#033B69",
	"blue-302": "#316797",
	"blue-303": "#538DD3",
	"blue-304": "#93CBFE",
	"blue-305": "#BCDFFD",
	"blue-306": "#E0EDFB",
	"blue-307": "#EBF3FA",
	"blue-308": "#070C1B66",
	"blue-309": "#001425",
	success: success,
	warning: warning,
	error: error,
	disabled: disabled,
	"disabled-text": "#A5A5A5",
	"compliant-green": "#116141",
	"compliant-brown": "#775413",
	"compliant-red": "#A93434",
	"compliant-text": "#707070",
	"data-red-orange": "#FF5900",
	"data-red-orange-70": "#FF8B4D",
	"data-red-orange-50": "#FFAC80",
	"data-red-orange-30": "#FFCDB3",
	"data-red-orange-20": "#FFDECC",
	"data-red-orange-12": "#FFEBE0",
	"data-red-orange-7": "#FFF3ED",
	"data-red-orange-4": "#FFF8F5",
	"data-magenta": "#C50270",
	"data-magenta-70": "#D34194",
	"data-magenta-50": "#E89AC6",
	"data-magenta-30": "#EEB3D4",
	"data-magenta-20": "#F3CCE2",
	"data-magenta-12": "#F8E1EE",
	"data-magenta-7": "#FBEDF5",
	"data-magenta-4": "#FDF5F9",
	"data-purple": "#682989",
	"data-purple-70": "#8A69AC",
	"data-purple-50": "#B08FD0",
	"data-purple-30": "#D2BFDC",
	"data-purple-20": "#E1D4E7",
	"data-purple-12": "#EDE5F1",
	"data-purple-7": "#F4F0F7",
	"data-purple-4": "#F9F6FA",
	"data-teal": "#115061",
	"data-teal-70": "#2F7E92",
	"data-teal-50": "#42A9BA",
	"data-teal-30": "#80BCCC",
	"data-teal-20": "#C2E7ED",
	"data-teal-12": "#DCEFF3",
	"data-teal-7": "#EEF3F4",
	"data-teal-4": "#F5F8F9",
	"data-green": "#1AA382",
	"data-green-70": "#5FBFA8",
	"data-green-50": "#8CD1C0",
	"data-green-30": "#BAE3DA",
	"data-green-20": "#D1EDE6",
	"data-green-12": "#E3F3EF",
	"data-green-7": "#EFF9F6",
	"data-green-4": "#F6FBFA",
	"data-cinnamon": "#B65611",
	"data-cinnamon-70": "#CC8958",
	"data-cinnamon-50": "#E2A974",
	"data-cinnamon-30": "#F4CFA3",
	"data-cinnamon-20": "#F8DEB8",
	"data-cinnamon-12": "#FFEFD7",
	"data-cinnamon-7": "#FFF6E8",
	"data-cinnamon-4": "#FFFAF2",
	"data-periwinkle": "#7086F5",
	"data-periwinkle-70": "#9BAAF8",
	"data-periwinkle-50": "#B8C2FA",
	"data-periwinkle-30": "#D4DBFC",
	"data-periwinkle-20": "#E3E7FD",
	"data-periwinkle-12": "#EEF0FE",
	"data-periwinkle-7": "#F5F7FE",
	"data-periwinkle-4": "#F9FAFF",
	"data-orange": "#FF9901",
	"data-orange-70": "#FFB84D",
	"data-orange-50": "#FFD480",
	"data-orange-30": "#FFEDAC",
	"data-orange-20": "#FFF3C7",
	"data-orange-12": "#FFF7E1",
	"data-orange-7": "#FFFAED",
	"data-orange-4": "#FFFDF5",
	"data-brown": "#9C6E19",
	"data-brown-70": "#C99100",
	"data-brown-50": "#E8B42E",
	"data-brown-30": "#F7D171",
	"data-brown-20": "#FBE19F",
	"data-brown-12": "#FEEDC2",
	"data-brown-7": "#FDF4DE",
	"data-brown-4": "#FEF9EE",
	"data-light-gray": "#5F5F5F",
	"data-light-gray-70": "#8F8F8F",
	"data-light-gray-50": "#AFAFAF",
	"data-light-gray-30": "#CFCFCF",
	"data-light-gray-20": "#DFDFDF",
	"data-light-gray-12": "#ECECEC",
	"data-light-gray-7": "#F4F4F4",
	"data-light-gray-4": "#F9F9F9",
	"data-brand": "#1B6EBB",
	"data-brand-70": "#589CDC",
	"data-brand-50": "#88B8E6",
	"data-brand-30": "#B8D5F0",
	"data-brand-20": "#CFE3F5",
	"data-brand-12": "#E2EEF9",
	"data-brand-7": "#EEF5FC",
	"data-brand-4": "#F5F9FD",
	annotation: annotation
};

export { annotation, black, brand, current, deprecated as default, disabled, error, success, transparent, warning, white };
